import styled from "styled-components"


export const AssetsPage = () => {
  return (
    <StyleWrap>
      AssetsPage
    </StyleWrap>
  )
}

const StyleWrap = styled.div`

`;